import { Component, OnInit, Input, Inject } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';

@Component({
    selector: 'fi-button-back',
    templateUrl: './button-back.component.html',
    standalone: false,
})
export class ButtonBackComponent implements OnInit {
    @Input() buttonTitle: String = this.appTextService.get('back');

    constructor(private appTextService: AppTextService) {}

    ngOnInit() {}

    back() {
        window.history.back();
    }
}
